import { Loader } from "@fanduel/og-fe-library";
import useRecentArticles from "@/utils/hooks/useRecentArticles";
import RelatedArticles from "./RelatedArticles";

interface RelatedArticlesContainerProps {
  sportName: string;
}

const RelatedArticlesContainer = ({
  sportName,
}: RelatedArticlesContainerProps) => {
  const { articles, isLoading } = useRecentArticles({ limit: 4, sportName });

  if (isLoading) {
    return <Loader size="medium" />;
  }

  if (!articles) {
    return <div />;
  }

  return <RelatedArticles articles={articles.slice(0, 4)} />;
};

export default RelatedArticlesContainer;
